<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  mounted() {
    Vue.nextTick(() => {
      Fandom.onEvent("toggle-registration-modal", () => {
        $("#modal-registration").modal("toggle");
      });
    });
  },
  computed: {
    unlockablePoints() {
      return get(this, ["content", "unlockable_points"], []);
    }
  },
  methods: {
    closeModal() {
      $("#modal-registration").modal("hide");
    }
  }
};
</script>

<template>
  <div modal-registration-component modal-components>
    <div id="modal-registration" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content" v-easyadmin="easyadminId" :class="contentType">
          <div class="modal-header border-bottom-0 px-2 px-md-3 py-2 pb-md-0 pt-md-3">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center px-4 px-md-5 pb-5 pt-0 pt-md-4">
            <div class="row justify-content-center">
              <div class="col-12 d-flex align-items-center mb-3" v-if="content.image">
                <img :src="content.image.url" class="w-100"/>
              </div>
              <div class="col-12">
                <h3 class="font-weight-light text-gray-900 text-left">{{content.title}}</h3>
                <div class="font-weight-normal text-gray-900 small mb-4 pb-md-3 text-left">{{content.subtitle}}</div>
                <div class="mb-1 mb-md-5" v-if="unlockablePoints.length > 0">
                  <div class="d-flex" v-for="(point, index) in unlockablePoints" :key="index">
                    <div class="icon-wrapper mr-md-4">
                      <img class="img-fluid" :src="point.icon.url" v-if="point.icon" >
                    </div>
                    <div class="text-left">
                      <span class="h6 font-weight-bold">{{point.title}}</span>
                      <p class="small">{{point.description}}</p>
                    </div>
                  </div>
                </div>
                <a href="/users/sign_up" class="btn btn-primary mb-3 d-block">{{ft('globals.register_now')}}</a>
                <span class="py-2 d-block small" v-html="ft('globals.already_registered')"></span>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[modal-registration-component] {

  .icon-wrapper {
    width: 6.5rem;
    height: 6.5rem;
    min-width: 6.5rem;
  }

  @include media-breakpoint-down(sm) {
    .icon-wrapper {
      width: 3.5rem;
      min-width: 3.5rem;
    }
    .img-fluid {
      max-width: 3rem;
    }
  }
}
</style>
